<template>
  <div class="dashboard__container" v-if="user">
    <div class="dashboard__container--body">
      <div class="dashboard__container--body--col">
        <div>
          <h4 class="mb-5">Request Background Checks</h4>
         <!--  <div class="mb-3">
            <v-select
              :options="statuses"
              v-model="userProfile.backgroundCheckStatus"
              @input="updateProfile()"
              :clearable="false"
              >
            </v-select>
          </div> -->
         <!--  <div class="mb-4">
            <button class="btn btn__outlined-primary" @click="orderBasic()" :disabled="user.basicCheckRequested">
              Order Basic Check
              <transition name="fade">
                <span class="ml-2" v-if="performingRequest1">
                <i class="fa fa-spinner fa-spin"></i>
                </span>
              </transition>
            </button>
          </div> -->
          <div class="mb-4">
            <button class="btn btn__outlined-primary" @click="orderPremium()" :disabled="user.backgroundCheckStatus">
              Order Premium Check
              <transition name="fade">
                <span class="ml-2" v-if="performingRequest2">
                <i class="fa fa-spinner fa-spin"></i>
                </span>
              </transition>
            </button>
            <button class="btn btn__outlined-primary ml-3" @click="orderPremium()" v-if="cancelledCheck && cancelledCheck.length >= 1">
              Re-Order Premium Check
              <transition name="fade">
                <span class="ml-2" v-if="performingRequest2">
                <i class="fa fa-spinner fa-spin"></i>
                </span>
              </transition>
            </button>
          </div>
          <div class="mb-4">
            <button class="btn btn__outlined-primary" @click="orderDrug()" :disabled="user.drugCheckRequested">
              Order Drug Test
              <transition name="fade">
                <span class="ml-2" v-if="performingRequest3">
                <i class="fa fa-spinner fa-spin"></i>
                </span>
              </transition>
            </button>
            <button class="btn btn__outlined-primary ml-3" @click="orderDrug()" v-if="cancelledDrug && cancelledDrug.length >= 1">
              Re-Order Drug Test
              <transition name="fade">
                <span class="ml-2" v-if="performingRequest3">
                <i class="fa fa-spinner fa-spin"></i>
                </span>
              </transition>
            </button>
          </div>
         <!--  <form @submit.prevent>
            <div class="mb-3">
              <label for="company">Company Ordered From:</label>
              <input type="text" placeholder="Checkr, etc" v-model.trim="check.company" id="company" />
            </div>
            <div class="mb-3">
              <label for="type">Order Type:</label>
              <input type="text" placeholder="Checkr, etc" v-model.trim="check.type" id="type" />
            </div>
            <button v-if="check.type && check.company" class="btn btn__primary mt-3" @click="addCheck()">Add Check
              <transition name="fade">
                <span class="ml-2" v-if="performingRequest">
                <i class="fa fa-spinner fa-spin"></i>
                </span>
              </transition>
            </button>
          </form> -->
        </div>
      </div>
    </div>
    <hr>
    <div class="dashboard__container--body">
      <div class="dashboard__container--body--col" style="width:100%;">
        <div>
          <vue-good-table
            :columns="columns"
            :rows="userBackgroundChecks"
            styleClass="vgt-table condensed"
            compactMode
            :pagination-options="{
              enabled: true,
              mode: 'records',
              perPage: 10,
            }"
            @on-row-click="onRowClick"
          >
           <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'note'">
                <span>{{props.row.note}}</span>
              </span>

              <span v-else-if="props.column.field == 'created'">
                <span>{{formatDate(props.row.created)}}</span>
              </span>

              <span v-else-if="props.column.field == 'submittedBy'">
                {{props.row.orderedBy.firstName}} {{props.row.orderedBy.lastName}} 
                <!-- <router-link :to="`/users/` + props.row.submittedBy" target="_blank">  <i class="fas fa-external-link"></i>
                </router-link> -->
              </span>
               <span v-else>
                {{props.formattedRow[props.column.field]}}
              </span>
            </template>

            
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Loader from '@/components/Loader.vue'
import * as moment from 'moment'
const fb = require('../../firebaseConfig.js')
import router from '@/router'

export default {
  props: ['user'],
  name: 'userBackgroundCheck',
  data: () => ({
    performingRequest1: false,
    performingRequest2: false,
    performingRequest3: false,
    statuses: ['ordered', 'cancelled'],
    check: {
      status: 'Ordered',
    },
    columns: [
      {
        label: 'Created',
        field: 'created',
      },
      {
        label: 'Type',
        field: 'type',
      },
      {
        label: 'Status',
        field: 'status',
      },
      {
        label: 'Response',
        field: 'response',
      },
      {
        label: 'Submitted By',
        field: 'orderedBy',
        html: true
      }
    ]
  }),

  computed: {
    ...mapState(['currentUser', 'userProfile', 'userBackgroundChecks']),
    cancelledCheck() {
      return this.userBackgroundChecks.filter(check => {
        return (check.type == 'Premium' && check.status == 'Cancelled')
      })
    },
    cancelledDrug() {
      return this.userBackgroundChecks.filter(check => {
        return (check.type == 'Drug' && check.status == 'Cancelled')
      })
    },
  },
  components: {
    Loader,
  },
  methods: {
    onRowClick(params) {
      console.log(params)
      let url = `/users/` + this.user.id + `/backgroundcheck/` + params.row.id
      router.push(url)
    },
    async orderBasic() {
      this.performingRequest1 = true
      let check = {
        orderedBy: this.userProfile.firstName + ' ' + this.userProfile.lastName,
        userId: this.user.id,
        user: this.user,
        type: 'Basic',
        status: 'Requested'
      }
      await fb.backgroundChecksCollection.add(check)
      fb.usersCollection.doc(this.user.id).update({
        jesBackground: true
      })
      this.performingRequest1 = false
    },
    async orderPremium() {
      this.performingRequest2 = true
      let check = {
        orderedBy: this.userProfile.firstName + ' ' + this.userProfile.lastName,
        userId: this.user.id,
        user: this.user,
        type: 'Premium',
        status: 'Requested'
      }
      await fb.backgroundChecksCollection.add(check)
      fb.usersCollection.doc(this.user.id).update({
        backgroundCheckStatus: 'Requested'
      })
      this.performingRequest2 = false
    },
    async orderDrug() {
      this.performingRequest3 = true
      let check = {
        orderedBy: this.userProfile.firstName + ' ' + this.userProfile.lastName,
        userId: this.user.id,
        user: this.user,
        type: 'Drug',
        status: 'Requested'
      }
      await fb.backgroundChecksCollection.add(check)
      fb.usersCollection.doc(this.user.id).update({
        drugCheckStatus: 'Requested'
      })
      this.performingRequest3 = false
    },
    formatDate(q) {
      if(q) {
        const postedDate = new Date(q.seconds) * 1000;
        return moment(postedDate).format('MMMM Do YYYY')
      } else {
        return null
      }
    },
    deleteItem (item) {
      fb.backgroundChecksCollection.doc(item.id).delete()
    },
  }
}

</script>